export enum AuthLevel
{
    HUB_MANAGER             =   30,
    ORG_MANAGER             =   20,
    SITE_MANAGER            =   10,
    CALLCENTER_OPERATOR     =    5,
    GENERIC_OPERATOR        =    0
}   
